<template>
  <div class="integration-general">
    <span class="integration-general__head">General</span>
    <div class="integration-general__content">
      <div class="integration-general__group">
        <Input
          className="field__input"
          label="Integration Name"
          name="integrationName"
          :required="true"
          v-model="value.name"
          :placeholder="'Required'"
        />
        <Input
          className="field__input"
          label="Alias Name"
          name="aliasName"
          :required="false"
          v-model="value.alias"
          :placeholder="'Optional'"
        />
        <Toggle
          :label="'Active'"
          :value="active"
          @mouseenter.native="tooltipStatusVisible = true"
          @focus.native="tooltipStatusVisible = true"
          @mouseleave.native="tooltipStatusVisible = false"
          @blur.native="tooltipStatusVisible = false"
        >
          <template slot="true-value">Active</template>
          <template slot="false-value">Inactive</template>
        </Toggle>
      </div>
      <div class="integration-general__group">
        <Dropdown
          label="Standard Type"
          :defaultValue="'Select one'"
          :required="true"
          :options="standardOptions"
          @change="changeStandardType"
          v-model="value.standarType"
        />
        <Dropdown
          :disabled="showAPIsOption"
          label="APIs"
          :defaultValue="'Select one or more'"
          :required="true"
          :options="apiOptions"
          :multiSelect="true"
          v-model="value.apis"
        />
        <SegmentedControl
          v-model="value.dmsis"
          name="IsDMSIntegrationSolution"
          :options="integrationStatusOptions"
          labelText="Does this integration use DMS-IS?"
          :required="true"
          @change="changeDMSIntegrationSolution"
          data-testid="IsDMSIntegrationSolution"
        >
        </SegmentedControl>
        <Dropdown
          :disabled="!value.dmsis"
          name="dmsis"
          label="Select a DMS-IS"
          :defaultValue="'Select one'"
          :required="value.dmsis"
          :options="dmsISOptions"
          v-model="value.DMSIntegrationId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Input from '@/components/forms/input/input';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';

import SegmentedControl from '@/components/forms/segmented-control/segmented-control';

export default {
  name: 'IntegrationGeneral',
  props: {
    // value is the integration obj
    value: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Toggle,
    Input,
    SegmentedControl,
    Dropdown,
  },

  data() {
    return {
      tooltipStatusVisible: false,
      integrationStatusOptions: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      dmsISOptions: [
        { value: '1', text: 'Test 1' },
        { value: '2', text: 'Test 2' },
      ],
      standardOptions: [
        { value: '1', text: 'Star Standard' },
        { value: '2', text: 'Adf Standard' },
        { value: '3', text: 'Xtime Standard' },
        { value: '4', text: 'PPNET Standard' },
      ],
      apiOptions: [
        { value: '1', text: 'GetCustomerInformation|5.9.3' },
        { value: '2', text: 'GetRetailDeliveryReporting|5.12.4' },
      ],
      showAPIsOption: true,
    };
  },
  computed: {
    active() {
      return this.value.status == 'Inactive' ? false : true;
    },
  },
  methods: {
    changeDMSIntegrationSolution(dmsis) {
      this.value.dmsis = dmsis;
    },
    changeStandardType(value) {
      this.showAPIsOption = value ? false : true;
    },
    requireFieldsAreNotEmpty() {
      const { name, standarType, apis, dmsis, DMSIntegrationId } = this.value;
      if (dmsis) {
        return !!(name && standarType && apis?.length > 0 && DMSIntegrationId);
      }
      return !!(name && standarType && apis?.length > 0);
    },
    async fetchMatchesIntegrationNames() {
      console.log('call api');
    },
    sendResult(isReadyToSend) {
      this.$emit('input', this.value);

      if (isReadyToSend) {
        this.$emit('valid', true);
        return;
      }
      this.$emit('valid', false);
    },
    checkRequiredFields() {
      if (this.requireFieldsAreNotEmpty()) {
        this.sendResult(true);
      } else {
        this.sendResult(false);
      }
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.checkRequiredFields();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .toggle {
  margin-top: $gutter-xl;
}

.integration-general {
  &__head {
    @include heading(md);
    margin-bottom: $gutter-lg;
  }

  &__content {
    margin-top: $gutter-lg;
  }

  &__group {
    display: grid;
    align-items: flex-start;
    gap: $gutter-xl;
    margin-bottom: $gutter-xl;
    grid-template-columns: 1fr 1fr 100px;

	* {
		min-width: 0;
	}

    &:last-child {
      @include mq($until: md-l) {
        grid-template-columns: 1fr 1fr;
        padding-right: 124px;
      }
    }

    @include mq($from: md-l) {
      gap: $gutter-xxl;
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
